import { z } from 'zod';

export type RegisterUserPayload = z.output<typeof registerUserPayloadSchema>;
export type RegisterUserPayloadDTO = z.input<typeof registerUserPayloadSchema>;

export const registerUserPayloadSchema = z.object({
  email: z.email(),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  password: z.string().min(8),
  invitationToken: z.string().optional(),
});
